import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import get from "@insite/mobius/utilities/get";

/**
 * Provides a flat object of camelCase css properties describing the typography of the inputs hosted inside the
 * Spreedly iframes. The object is passed as-is to `setStyles` of the Spreedly Checkout SDK, which only accepts
 * plain css properties - borders, sizing and focus/error states are applied to the container element instead.
 * @param {object} props The Props object of the form component.
 * @param {object} props.theme The site's theme object.
 * @param {object} [props.theme.typography.body.fontFamily] Base font family on the site.
 * @param {string} [props.theme.typography.body.size] Base font size for the site.
 * @param {string} [props.theme.colors.text.main] Base text color for the site.
 * @return {object} config object describing the Spreedly hosted field styles.
 */
export const generateSpreedlyFrameStyleConfig = (props: {
    theme: BaseTheme;
    sizeVariant?: "default" | "small";
    border?: "underline" | "rectangle" | "rounded";
    cssOverrides?: object;
}): Record<string, string> => {
    const { theme } = props;

    return {
        fontFamily: `${get(theme, "typography.body.fontFamily")}`,
        fontSize: `${get(theme, "typography.body.size")}`,
        color: `${get(theme, "colors.text.main")}`,
        backgroundColor: "transparent",
        padding: "0 10px",
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
    };
};
